import React from 'react';
import styles from './css/Templates.module.scss';

export default function SocialMedia () {
  const backgrounds = [
    { src: 'https://res.cloudinary.com/dsg2ktuqk/image/upload/v1720047950/Templates/WhatsApp_Image_2024-03-03_at_18.39_22_fxcmng.png' },
    { src: 'https://res.cloudinary.com/dsg2ktuqk/image/upload/v1720047951/Templates/WhatsApp_Image_2024-03-03_at_18.39_23_a5ckby.png' },
    { src: 'https://res.cloudinary.com/dsg2ktuqk/image/upload/v1720047951/Templates/WhatsApp_Image_2024-03-03_at_18.39_21_zgflre.png' },
    { src: 'https://res.cloudinary.com/dsg2ktuqk/image/upload/v1720047950/Templates/WhatsApp_Image_2024-03-03_at_18.39_22_fxcmng.png' }
  ];
  return (
    <div className={styles.container}>
      <div className={`${styles.templates__container}`}>
        <h1>Social Media</h1>
        <small>
          Get the inspiration you need and boost your creativity
        </small>
        <div className={styles.socialmedia}>
          {backgrounds.map((item, i) => {
            return (
              <img src={item.src} key={i} />
            )
          })}
        </div>
      </div>
    </div>
  )
}
